export default {
  weekday_0: "Mo",
  weekday_1: "Di",
  weekday_2: "Mi",
  weekday_3: "Do",
  weekday_4: "Fr",
  weekday_5: "Sa",
  weekday_6: "So",
  weekday_other: "Reserve",
  shortcut_title: "Shortcuts",
  shortcut_feature: "Funktion",
  shortcut_shortcut: "Shortcut",
  shortcut_TODO_ITEM: "Eintrag",
  shortcut_INCREMENT: "Erhöhen",
  shortcut_DECREMENT: "Verringern",
  shortcut_MOVE_UP: "Nach oben verschieben",
  shortcut_MOVE_DOWN: "Nach unten verschieben",
  shortcut_EDIT: "Bearbeiten",
  shortcut_EDIT_VIEW: "Bearbeitungs-Ansicht",
  shortcut_FOCUS_INPUT: "Neuer Eintrag",
  shortcut_PREVIOUS_LIST: "Vorherige Liste",
  shortcut_NEXT_LIST: "Nächste Liste",
  shortcut_SHOPPING_MODE: "Wechsel zu Einkaufs-Ansicht",
  shortcut_SHOPPING_VIEW: "Einkaufs-Ansicht",
  shortcut_EDIT_MODE: "Wechsel zu Bearbeitungs-Ansicht",
  drawer_version: "Listhero Version",
  drawer_accountid: "Account-ID",
  drawer_copysync: "Sync-Link kopieren",
  drawer_copysync_description: "Dieser Link gibt Zugriff auf deinen Account",
  drawer_copysyncqr: "Sync-Link als Qr Code anzeigen",
  drawer_scanqr: "Sync-Qr-Code abscannen",
  drawer_log: "Verlauf",
  drawer_resync: "Neu synchronisieren",
  drawer_newaccount: "Neuen Account erstellen",
  drawer_newaccount_description:
    "Ohne Sync-Link geht dein aktueller Account verloren",
  drawer_shortcuts: "Shortcuts",
  drawer_newaccount_dialog:
    "Willst du deinen aktuellen Account wirklich verwerfen?",
  list_shoppingview_label: "Einkaufs-Ansicht",
  list_editview_label: "Editieren",
  list_entries: "Einträge",
  list_newentry: "Neuer Eintrag",
  list_noentries: "Alles erledigt!",
  copysyncqr_title: "Sync-Link",
  copysyncqr_explanation: "Dieser QR-Code gibt Zugriff auf deinen Account.",
  recentused_title: "Zuletzt verwendet",
  recentused_search_placeholder: "Einträge filtern",
  recentused_sort_chronological: "Chronologisch sortieren",
  recentused_sort_alphabetical: "Alphabetisch sortieren",
  scanqr_title: "Sync-Link einlesen",
  scanqr_scan: "Scanne einen Sync-Qr-Code",
  scanqr_paste: "oder füge hier einen Link ein",
  login_title: "Konten-Synchronisierung",
  login_error: "Die Anmeldung konnte nicht durchgeführt werden.",
  login_servererror: "Überprüfe das Server-Passwort.",
  login_login: "Login",
  login_createaccount: "Account erstellen",
  login_overwritewarning: ` Achtung, dein aktuelles Nutzerkonto wird bei der Synchronisierung
überschrieben. Wenn du dein Konto nicht verlieren willst, sichere
dir zuerst den Synchronisierungs-Link.`,
  login_overwrite: "Synchronisieren",
  login_copysynclink: "Sync-Link für aktuelles Konto kopieren",
  lists_menu_label: "Menü",
  lists_title: "Alle Listen",
  lists_addlist_label: "Liste hinzufügen",
  lists_welcome: `
    Noch keine Listen angelegt.
    Tippe rechts oben "+", um eine Liste hinzuzufügen.

    Einträge können über mehrere Geräte synchronisiert werden.
    Öffne Links oben das Menü, um den Sync-Code zu kopieren.
  `,
  lists_entries: "Einträge",
  listmenu_rename: "Umbenennen",
  listmenu_clear: "Leeren",
  listmenu_remove: "Löschen",
  listmenu_toweekplan: "In Wochenplan umwandeln",
  listmenu_tolist: "In normale Liste umwandeln",
  listmenu_copy: "In Zwischenablage kopieren",
  listmenu_log: "Verlauf",
  confirmdialog_cancel: "Abbrechen",
  confirmdialog_confirm: "OK",
  itemmenu_moveto_back: "Zurück",
  itemmenu_tobottom: "Nach unten verschieben",
  itemmenu_done: "Abhaken",
  itemmenu_moveto: "Auf Liste verschieben",
  namedialog_cancel: "Abbrechen",
  namedialog_confirm: "Speichern",
  serverpassword_label: "Server-Passwort",
  snackbar_listremove_label: "gelöscht",
  snackbar_listremove_action: "Rückgängig",
  log_title: "Verlauf",
  log_loading: "Lade...",
  log_placeholder: "Filtern nach Liste",
  log_item_ADD_LIST: "Liste {{ list }} hinzugefügt",
  log_item_ADD_ITEM: "Eintrag {{ item }} zu {{ list }} hinzugefügt",
  log_item_REMOVE_ITEM: "Eintrag {{ item }} von {{ list }} gelöscht",
  log_item_REMOVE_RECENTLY_USED_ITEM:
    "Eintrag {{ item }} von zuletzt verwendeten Einträgen von {{ list }} gelöscht",
  log_item_EDIT_ITEM:
    "Eintrag {{ oldItem }} zu {{ item }} auf {{ list }} geändert",
  log_item_REMOVE_LIST: "Liste {{ list }} gelöscht",
  log_item_MOVE_ITEM_TO_LIST:
    "Eintrag {{ item }} von {{ oldList }} zu {{ list }} verschoben"
};



// WEBPACK FOOTER //
// ./src/translations/de.js